/**
 * Geräteklassen-Heuristik für Render-Budgets (26.08.2026, Jans iPhone-
 * Absturz-Fund an der Glas/Spiegel/Porsche-Stress-Szene).
 *
 * iOS killt den Tab hart, wenn WebKit ~1-1,5 GB überschreitet — auf dem
 * Laptop läuft dieselbe Szene locker. Touch-Geräte (pointer: coarse)
 * bekommen deshalb gedeckelte Budgets: Canvas-Pixeldichte, Spiegel-
 * Auflösung/-Takt, Cube-Reflexions-Takt. Bewusst EINE zentrale Heuristik
 * statt verstreuter UA-Sniffs; iPads fallen mit hinein (gleiche
 * WebKit-Grenzen).
 */
export function istMobilesGeraet(): boolean {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
        return false;
    }
    try {
        return window.matchMedia("(pointer: coarse)").matches;
    } catch {
        return false;
    }
}

/**
 * Textur-Deckel fuer Touch-Geraete (Jans Wunsch 26.08.2026): Bild-Texturen
 * groesser als 2048 Kantenlaenge vor dem GPU-Upload herunterskalieren.
 * Eine 4096er-RGBA-Textur belegt ~67 MB GPU-Speicher (mit Mips) — auf
 * Handy-Displays ist der Unterschied zu 2048 nicht sichtbar, der
 * WebKit-Speicherdeckel dagegen sehr real. Greift nur bei echten
 * Bildquellen (Image/ImageBitmap/Canvas) — DataTexturen wie die HDRI
 * haben ihren eigenen Deckel (verkleinereEquirectFuerMobil).
 */
export const MOBILE_TEXTUR_KANTE = 2048;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deckleTexturFuerMobil(texture: any): void {
    if (!texture || !istMobilesGeraet()) return;
    const img = texture.image;
    const w: number = img?.width || 0;
    const h: number = img?.height || 0;
    if (!w || !h || Math.max(w, h) <= MOBILE_TEXTUR_KANTE) return;
    const istBildquelle =
        (typeof HTMLImageElement !== "undefined" && img instanceof HTMLImageElement) ||
        (typeof ImageBitmap !== "undefined" && img instanceof ImageBitmap) ||
        (typeof HTMLCanvasElement !== "undefined" && img instanceof HTMLCanvasElement);
    if (!istBildquelle) return;
    try {
        const f = MOBILE_TEXTUR_KANTE / Math.max(w, h);
        const canvas = document.createElement("canvas");
        canvas.width = Math.max(1, Math.round(w * f));
        canvas.height = Math.max(1, Math.round(h * f));
        canvas.getContext("2d")!.drawImage(img, 0, 0, canvas.width, canvas.height);
        texture.image = canvas;
        texture.needsUpdate = true;
    } catch {
        // Deckeln ist reine Optimierung — im Zweifel Original behalten.
    }
}
